import getPieveActivityEventText from '@/lib/activityEvents/getPieveActivityEventText.js';
import toComparableUserPromptTextVariants from '@/lib/activityEvents/toComparableUserPromptTextVariants.js';

const toComparableAttachmentKeys = (event = {}) => {
  return (Array.isArray(event?.attachments) ? event.attachments : [])
    .map((attachment) => {
      return String(attachment?.attachmentId || attachment?.filename || '').trim();
    })
    .filter(Boolean)
    .sort();
};

const areEquivalentUserPromptEvents = ({ existingEvent, incomingEvent, maxDeltaMs = 120000 }) => {
  const isUserBubbleEvent = (event = {}) => {
    if (event?.type !== 'bubble') {
      return false;
    }

    return (
      String(event?.className || '')
        .trim()
        .toLowerCase() === 'user'
    );
  };
  const hasPendingRunId = (value) => {
    return String(value || '')
      .trim()
      .startsWith('pending-');
  };

  if (!isUserBubbleEvent(existingEvent) || !isUserBubbleEvent(incomingEvent)) {
    return false;
  }

  const existingTexts = toComparableUserPromptTextVariants(getPieveActivityEventText(existingEvent));
  const incomingTexts = toComparableUserPromptTextVariants(getPieveActivityEventText(incomingEvent));

  if (existingTexts.length > 0 || incomingTexts.length > 0) {
    const hasMatchingComparableText = existingTexts.some((existingText) => {
      return incomingTexts.includes(existingText);
    });

    if (!hasMatchingComparableText) {
      return false;
    }
  } else {
    /* A prompt made of attachments alone has no text to compare: the files are its identity. */
    const existingAttachmentKeys = toComparableAttachmentKeys(existingEvent);
    const incomingAttachmentKeys = toComparableAttachmentKeys(incomingEvent);

    if (existingAttachmentKeys.length < 1 || existingAttachmentKeys.length !== incomingAttachmentKeys.length) {
      return false;
    }

    if (existingAttachmentKeys.some((key, index) => key !== incomingAttachmentKeys[index])) {
      return false;
    }
  }

  const existingRunId = String(existingEvent?.runId || '').trim();
  const incomingRunId = String(incomingEvent?.runId || '').trim();

  if (existingRunId && incomingRunId && existingRunId !== incomingRunId && !hasPendingRunId(existingRunId) && !hasPendingRunId(incomingRunId)) {
    return false;
  }

  const existingCreatedAtMs = Date.parse(existingEvent?.createdAt || '');
  const incomingCreatedAtMs = Date.parse(incomingEvent?.createdAt || '');

  if (!Number.isFinite(existingCreatedAtMs) || !Number.isFinite(incomingCreatedAtMs)) {
    return true;
  }

  return Math.abs(existingCreatedAtMs - incomingCreatedAtMs) <= maxDeltaMs;
};

export default areEquivalentUserPromptEvents;
